<template>
  <div>
    <v-row cols="12">
      <v-col cols="3" sm="3">
        <v-select
          id="customerSelect"
          v-model="selectedCustomers"
          :items="customerSelection"
          :label="'Kunden'"
          outlined
          dense
          multiple
          required
          @change="filterOrders()"
        ></v-select>
      </v-col>
      <v-col cols="3" sm="3">
        <v-select
          id="regionSelect"
          v-model="selectedRegions"
          :items="regionSelection"
          :label="'Leitregionen'"
          outlined
          dense
          multiple
          required
          @change="filterOrders()"
        ></v-select>
      </v-col>
      <v-col cols="3" sm="3"> </v-col>
    </v-row>
    <ProductionHistoryTable
      :orders="displayedOrders"
      @setItems="() => {}"
      @setOrderValues="() => {}"
    ></ProductionHistoryTable>
  </div>
</template>

<script>
import ProductionHistoryTable from '@/components/tables/ProductionHistoryTable'
export default {
  components: {
    ProductionHistoryTable
  },
  data: () => ({
    content: {},
    isValidationDialogOpen: false,
    validationResult: null,
    isErrorDialogOpen: false,
    selectedCustomers: '',
    regionSelection: [],
    selectedRegions: [],
    customerSelection: [],
    fetchedOrders: [],
    displayedOrders: []
  }),
  created: function() {
    this.fetchOrders()
  },
  methods: {
    fetchOrders() {
      this.fetchedOrders = [
        {
          name: 'myName',
          customer: 'customer1',
          region: '00',
          sheetAmount: 1000,
          weight: 5,
          fullBatches: 5,
          partialBatches: 1,
          delete: '',
          id: 1
        },
        {
          name: 'myName',
          customer: 'customer1',
          region: '00',
          sheetAmount: 1000,
          weight: 6,
          fullBatches: 5,
          partialBatches: 1,
          delete: '',
          id: 2
        },
        {
          name: 'myName',
          customer: 'customer2',
          region: '02',
          sheetAmount: 1000,
          weight: 7,
          fullBatches: 6,
          partialBatches: 1,
          delete: '',
          id: 3
        },
        {
          name: 'myName',
          customer: 'customer3',
          region: '05',
          sheetAmount: 1300,
          weight: 8,
          fullBatches: 6,
          partialBatches: 1,
          delete: '',
          id: 4
        }
      ]
      this.displayedOrders = this.fetchedOrders
      this.customerSelection = this.getCustomerselection()
      this.regionSelection = this.getRegionselection()
    },
    filterOrders: function() {
      let customerArray = this.selectedCustomers
      let regionArray = this.selectedRegions
      let filteredOrders = []

      if (this.selectedCustomers.length === 0) {
        customerArray = this.getCustomerselection()
      }

      if (this.selectedRegions.length === 0) {
        regionArray = this.getRegionselection()
      }

      // create rendered List from all elements, that are selected in selectboxes
      this.fetchedOrders.forEach(fetchedOrder => {
        customerArray.forEach(selectedCustomer => {
          regionArray.forEach(selectedRegion => {
            if (
              selectedCustomer == fetchedOrder.customer &&
              selectedRegion == fetchedOrder.region
            ) {
              filteredOrders.push(fetchedOrder)
            }
          })
        })
      })

      this.displayedOrders = filteredOrders
    },
    getCustomerselection: function() {
      let nameArray = []
      this.fetchedOrders.forEach(element => {
        nameArray.push(element.customer)
      })

      // remove redundant elements
      nameArray = Array.from(new Set(nameArray))

      return nameArray
    },
    getRegionselection() {
      const regionArray = []
      for (let i = 0; i <= 99; i++) {
        if (i < 10) {
          regionArray.push('0' + i.toString())
        } else {
          regionArray.push(i.toString())
        }
      }
      return regionArray
    },
    deleteUser: function(id) {
      let Users = this.displayedUsers.filter(element => element.id !== id)
      this.displayedUsers = Users
    }
  }
}
</script>

<style></style>
